import { Component, Inject } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

interface AlertDialogComponentData {
  message: string;
  title?: string;
  buttonCaption?: string;
}

@Component({
  selector: 'cloud-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
})
export class AlertDialogComponent {
  message: string;
  title: string;
  buttonCaption: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: AlertDialogComponentData,
    public dialogRef: MatDialogRef<AlertDialogComponent>
  ) {
    this.title = data.title ?? $localize`Уведомление`;
    this.buttonCaption = data.buttonCaption ?? $localize`Ок`;
    this.message = data.message;
  }
}
